<template>
  <div
    class="w-full bg-indigo-50 border border-indigo-200 rounded-lg p-4 flex items-start space-x-2"
  >
    <Info class="text-indigo-500" />
    <p class="text-sm text-indigo-700">
      Values shown in non-Euro currencies are based on latest conversion rates
      and may change frequently.
    </p>
  </div>
</template>

<script>
import { Info } from 'lucide-vue-next'

export default {
  name: "CurrencyNotice",
  components: {
    Info,
  },
};
</script>
